import { render, staticRenderFns } from "./PayoutDetailsTableModal.vue?vue&type=template&id=35ab41a4"
import script from "./PayoutDetailsTableModal.vue?vue&type=script&lang=js"
export * from "./PayoutDetailsTableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports